/**
 * @file index.tsx
 *
 * @fileoverview Util methods for navigation.
 */

import { MenuLinkItem } from '~/jobiqo/models/navigation';

/**
 * Will check for paths that the user should not see. When a user is access denied to a path
 * drupal returns the string "Inaccessible".
 *
 * @param {MenuLinkItem} link
 *  The menu link.
 * @returns {boolean}
 *  Boolean value indicating if the user should see the link.
 */
export function checkHiddenMenu(link: MenuLinkItem): boolean {
  return link.title === 'Inaccessible';
}
